<template>
  <image-cropper-upload :url="url" @uploaded="handleUploaded">
  </image-cropper-upload>
</template>

<script lang="babel">
import ImageCropperUpload from '@/components/ImageCropperUpload';

export default {
  components: {
    ImageCropperUpload,
  },
  props: {
    customerProfile: {
      required: true,
      type: Number,
    }
  },
  methods: {
    handleUploaded() {

      this.$http.get(this.url).then(({data}) => {
        for (let i = 0; i< data.length-1; i++) {
          this.$http.delete(`/api/v1/customerMedia/${data[i].id}`);
        };
        this.$http.post(`/api/v1/customerMedia/${data[data.length-1].id}/primary`);
      });
      this.$bus.$emit('media-uploaded');
    }
  },
  computed: {
    url() {
      return `/api/v1/customerProfile/${this.customerProfile}/customerMedia`;
    },
  }
}
</script>
